export default function SolutionsCta() {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background */}
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20dark%20blue%20technology%20background%2C%20digital%20network%20connections%2C%20professional%20enterprise%20atmosphere%2C%20deep%20navy%20gradient%2C%20no%20people%2C%20no%20text&width=1400&height=400&seq=sol_cta01&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0d1f3c]/95 via-[#0d1f3c]/85 to-[#0a3060]/80"></div>
          </div>

          {/* Content */}
          <div className="relative z-10 px-10 lg:px-16 py-14 lg:py-16 flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/10 border border-white/20 rounded-full mb-5">
                <div className="w-1.5 h-1.5 rounded-full bg-[#4db8ff] animate-pulse"></div>
                <span className="text-[#4db8ff] text-xs font-medium">立即开始</span>
              </div>
              <h2 className="text-2xl lg:text-3xl font-bold text-white mb-3 leading-snug">
                无论您需要安全防护、架构升级
                <br className="hidden lg:block" />
                还是智慧园区建设，我们都能提供最佳方案
              </h2>
              <p className="text-gray-400 text-sm max-w-xl leading-relaxed">
                专业顾问团队随时待命，为您量身定制最优解决方案，助力企业数字化转型
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
              <a
                href="/#contact-form"
                className="px-7 py-3.5 bg-[#1a56db] hover:bg-[#1e40af] text-white font-semibold rounded-full transition-all duration-200 text-sm text-center whitespace-nowrap cursor-pointer"
              >
                联系我们获取定制方案
              </a>
              <a
                href="/#contact-form"
                className="px-7 py-3.5 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold rounded-full transition-all duration-200 text-sm text-center whitespace-nowrap cursor-pointer"
              >
                咨询技术专家
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
